import { msalConfig } from './auth-config';
import createPublicClientApplication from './create-public-client-application';

const client = createPublicClientApplication(msalConfig);

export default client;
